export const resolveImageLibraryLabel = (translations, fallbackLabel) => {
  const translatedTitle = translations?.modals?.addYourImageGallery?.addYourImageGalleryTitle;

  return typeof translatedTitle === "string" && translatedTitle.trim()
    ? translatedTitle
    : fallbackLabel;
};
